import * as React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Category } from "../../api/classes";
import { DubitoSvc } from "src/api";
import { GlobalState } from "src/store";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
interface Props {
  open: boolean;
  element: Category;
  onCancel: () => void;
  onEdit: () => void;
  fetchCategories: () => void;
}
class EditCategory extends React.Component<Props> {
  state = {
    open: this.props.open,
    categoryName: this.props.element ? this.props.element.title : ""
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onCancel();
  };
  handleApprove = () => {
    if (this.props.element) {
      this.editCategory();
    } else {
      this.addCategory();
    }
  };
  componentWillReceiveProps(next: Props) {
    this.setState({
      open: next.open,
      categoryName: next.element ? next.element.title : ""
    });
  }
  addCategory = () => {
    if (this.state.categoryName.length < 2) {
      return;
    }
    DubitoSvc.createCategory({ title: this.state.categoryName }).then(res => {
      this.props.fetchCategories();
      this.props.onEdit && this.props.onEdit();
    });
  };
  editCategory = () => {
    if (this.state.categoryName.length < 2) {
      return;
    }
    DubitoSvc.editCategory({
      category_id: this.props.element.id,
      title: this.state.categoryName
    }).then(res => {
      this.props.fetchCategories();
      this.props.onEdit && this.props.onEdit();
    });
  };
  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          style={{ minWidth: 500 }}
          maxWidth="sm"
          fullWidth
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {this.props.element ? "Edit Category" : "Add Category"}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Category Name"
              type="name"
              value={this.state.categoryName}
              onChange={e => this.setState({ categoryName: e.target.value })}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleApprove} color="primary">
              {this.props.element ? "Edit" : "Add"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({}),
  dispatch => ({
    fetchCategories: (): any => dispatch(actions.fetchCategories())
  })
)(EditCategory);



// WEBPACK FOOTER //
// ./src/pages/categories/edit.tsx